<div id="pantallaCompleta" #pantallaCompleta>
    <div style="height:30px" (mouseenter)="barraVisible = true;" class="d-print-none"></div>
    <!-- <app-navbar [ngClass]="navBarVisible()" (mouseleave)="barraVisible = false;" id="navBar" style="width : 99%;"></app-navbar> -->
    <app-navbar [ngClass]="navBarVisible()" (mouseleave)="ocultarNavBar();" (mouseenter)="barraVisible=true; ocultarBarra = false;" id="navBar" style="width : 99%;"></app-navbar>
    <router-outlet></router-outlet>
    <!-- <div class="d-print-none">Usuario: {{usuario}} - Base de datos: {{url}}</div> -->
    <app-menu-rapido *ngIf="menuRapidoVisible"></app-menu-rapido>
    <div class="d-print-none fade-out-image">Usuario: {{usuario}} - Base de datos: {{url}}</div>
</div>